module.exports = __webpack_public_path__ + "static/media/Duan2.52236c82.png";